import React from 'react';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import { MarketingBoldLink } from 'components/MarketingPagesShared/styles';
import { useT } from 'client/i18n/hooks/useT';
import {
  HomeImageCaption,
  HomeSectionTitle,
  HomeIconedCaption,
} from '../../../styles';
import { HomeSectionWithBackground } from '../../HomeSectionWithBackground';
import { MonetizeIcon } from '../../icons/MonetizeIcon';

export function HomeMonetize({ onClickCTA }: { onClickCTA?: () => void }) {
  const t = useT();
  return (
    <HomeSectionWithBackground
      backgroundImagePath="bg-monetize.svg"
      textColumn={
        <>
          <HomeSectionTitle
            dangerouslySetInnerHTML={{
              __html: t(
                'HomePage.HomeMonetize.Title',
                '<strong>Unlock sponsorships or set up a subscription</strong> so you can make money as your audience grows.',
                'Anchor home page monetization features section title'
              ),
            }}
          />
          <MarketingBoldLink to="/features#monetization" onClick={onClickCTA}>
            {t(
              'HomePage.HomeMonetize.MonetizationFeaturesLinkText',
              'See all monetization features',
              'Anchor home page monetization features link text'
            )}
          </MarketingBoldLink>
        </>
      }
      imageColumn={
        <>
          <MarketingImage
            width={520}
            height={520}
            imagePath="home/monetize"
            alt={t(
              'HomePage.HomeMonetize.MonetizationImageAlt',
              '{hostName} from the {podcastName} podcast tending to her plants at home',
              'Anchor home page monetization image screenreader information',
              {
                hostName: 'Athena Calderone',
                podcastName: 'More Than One Thing',
              }
            )}
          />
          <HomeIconedCaption>
            <MonetizeIcon />
            <HomeImageCaption
              dangerouslySetInnerHTML={{
                __html: t(
                  'HomePage.HomeMonetize.MonetizationImageCaption',
                  '<strong>“{podcastName}”</strong> has matched with multiple brand campaigns through Sponsorships.',
                  'Anchor home page monetization image caption',
                  { podcastName: 'More Than One Thing' }
                ),
              }}
            />
          </HomeIconedCaption>
        </>
      }
    />
  );
}
